import './style.modules.scss'

import { Card, CardRecord } from '@ampcore/adel-react'
import { VideoPlayerProvider } from '@ampcore/video-player'
import React from 'react'
import xss from 'xss'

import { VideoCard } from '../VideoCard/VideoCard'
import type { VideoCardRecord } from '../VideoCard/VideoCardRecord.type'

function isCardVideoRecord(
  card: CardRecord | VideoCardRecord
): card is VideoCardRecord {
  return 'playlistId' in card
}

export type CardGridButton = {
  linkHref: string
  linkTarget?: string
  analytics?: string
  linkText: string
}

export type CardGridProps = {
  cardDescription?: string
  cardList: CardRecord[] | VideoCardRecord[]
  cardLimit?: string
  componentSpacing?: string
  cardGridHeadline?: string
  button?: CardGridButton | null
  testId?: string
}

export const CardGrid: React.FC<CardGridProps> = ({
  componentSpacing = '',
  cardLimit = '3',
  cardList = [],
  cardGridHeadline = '',
  cardDescription = '',
  button = null,
  testId
}) => {
  const buildButton = () => {
    if (!button) return null
    const { linkHref, linkTarget, analytics, linkText } = button
    return (
      <a
        className="Button Button--secondary Button--secondary--action-blue Button--small"
        href={linkHref}
        target={linkTarget}
        data-analytics={analytics ?? ''}
      >
        {linkText}
      </a>
    )
  }

  return (
    <section
      className={`card-grid-component ${componentSpacing}`}
      data-limit={cardLimit}
    >
      <div className="Grid u-sizeConstrained" data-testid={testId ?? undefined}>
        <div className="u-flex u-flexJustifyBetween">
          {cardGridHeadline && (
            <h2 className="u-textColorDefault u-marginBottom16">
              {cardGridHeadline}
            </h2>
          )}
          {button && (
            <div className="Button--customSmallHidden">{buildButton()}</div>
          )}
        </div>
        {cardDescription && (
          <div
            className="card-description Content u-marginBottom20"
            dangerouslySetInnerHTML={{ __html: xss(cardDescription) }}
          />
        )}
        <div className="card-list-wrapper u-sm-flex u-sm-flexCol u-marginBottom20">
          <VideoPlayerProvider>
            {cardList.map((card, index) =>
              isCardVideoRecord(card) ? (
                <VideoCard key={'card' + index} card={card} />
              ) : (
                <Card key={index} card={card} />
              )
            )}
          </VideoPlayerProvider>
        </div>
        {button && (
          <div className="u-flex u-flexJustifyCenter Button--customSmallShow u-md-hidden u-lg-hidden">
            {buildButton()}
          </div>
        )}
      </div>
    </section>
  )
}
